import {useEffect} from 'react';
import {growthBook} from '../index';
import Analytics from '../utils/Analytics';
import {getLinkOutSession} from '../utils/linkOutSession';

/**
 * The person id `LinkOutGate` redeemed from the app's link-out token, when it is this page's `token`; otherwise null
 * (a legacy `?token=` link or an email address, which only `stripe-setup-checkout` can resolve).
 *
 * A checkout that already knows the person doesn't need to wait for `stripe-setup-checkout` before showing the
 * payment UI. That call identified the visitor to Segment and GrowthBook, so this does the same on mount: flags the
 * payment UI reads (`paywall_link_out_custom_cta`, the I21 dismiss treatment) are evaluated for this person, and
 * events fired before Hypnos answers are attributed to them. Segment queues the identify until it has loaded.
 */
export default function useRedeemedPersonId(token: string | null): string | null {
  const personId = token && getLinkOutSession()?.personId === token ? token : null;

  useEffect(() => {
    if (!personId) {
      return;
    }
    Analytics.identify(personId);
    if (!growthBook.getAttributes().personId) {
      growthBook.setAttributes({...growthBook.getAttributes(), personId});
    }
  }, [personId]);

  return personId;
}
